'use client';

import { c as _c } from "react/compiler-runtime";
import queryString from 'query-string';
// This hook is intended for use in Next.js environment only
// and there is a legacy counterpart for this as well
// eslint-disable-next-line import/no-unresolved
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { useMemo, useCallback } from 'react';
import { debounce } from 'lodash';
import { ALGOLIA_INDEX_NAME, DEFAULT_SORT_ORDER } from 'commons/constants';
import { CATEGORY_INDEX_MAPPING } from '../../commons/helpers';
const normalizeCategoryParam = raw => CATEGORY_INDEX_MAPPING[raw] || raw || ALGOLIA_INDEX_NAME.PRODUCTS;
const useAdvancedSearchNextURL = () => {
  const $ = _c(29);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const rawCategoryParam = searchParams?.get("category") ?? ALGOLIA_INDEX_NAME.PRODUCTS;
    t0 = normalizeCategoryParam(rawCategoryParam);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const categoryUrlParam = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams?.get("q") ?? "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const queryUrlParam = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams?.get("sortBy") ?? DEFAULT_SORT_ORDER;
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const sortByUrlParam = t2;
  let t3;
  if ($[6] !== searchParams) {
    t3 = searchParams?.get("type") ?? null;
    $[6] = searchParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const activeTypeFilter = t3;
  let t4;
  if ($[8] !== searchParams) {
    t4 = searchParams?.get("pages") ?? "0";
    $[8] = searchParams;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const parsedPagesUrlParam = parseInt(t4, 10);
  let t5;
  if ($[10] !== parsedPagesUrlParam) {
    t5 = Number.isFinite(parsedPagesUrlParam) && parsedPagesUrlParam >= 0 ? parsedPagesUrlParam : 0;
    $[10] = parsedPagesUrlParam;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const pagesUrlParam = t5;
  let t6;
  if ($[12] !== pathname || $[13] !== router || $[14] !== searchParams) {
    t6 = debounce(updates => {
      if (updates) {
        const prev = Object.fromEntries(searchParams);
        const merged = {
          ...prev,
          ...updates
        };
        const updatedUrlParams = queryString.stringify(merged);
        const newPath = `${pathname}${!pathname.endsWith("/") ? "/" : ""}?${updatedUrlParams}`;
        router.replace(newPath, {
          scroll: false
        });
      }
    }, 500);
    $[12] = pathname;
    $[13] = router;
    $[14] = searchParams;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const debouncedUpdateUrlParam = t6;
  let t7;
  if ($[16] !== pathname || $[17] !== router || $[18] !== searchParams) {
    t7 = updates_0 => {
      if (updates_0) {
        const prev_0 = Object.fromEntries(searchParams);
        const merged_0 = {
          ...prev_0,
          ...updates_0
        };
        const updatedUrlParams_0 = queryString.stringify(merged_0);
        const newPath_0 = `${pathname}${!pathname.endsWith("/") ? "/" : ""}?${updatedUrlParams_0}`;
        router.replace(newPath_0, {
          scroll: false
        });
      }
    };
    $[16] = pathname;
    $[17] = router;
    $[18] = searchParams;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const updateUrlParamImmediate = t7;
  let t8;
  if ($[20] !== activeTypeFilter || $[21] !== categoryUrlParam || $[22] !== debouncedUpdateUrlParam || $[23] !== pagesUrlParam || $[24] !== pathname || $[25] !== queryUrlParam || $[26] !== sortByUrlParam || $[27] !== updateUrlParamImmediate) {
    t8 = {
      pathname,
      queryUrlParam,
      categoryUrlParam,
      activeTypeFilter,
      sortByUrlParam,
      pagesUrlParam,
      updateUrlParam: debouncedUpdateUrlParam,
      updateUrlParamImmediate
    };
    $[20] = activeTypeFilter;
    $[21] = categoryUrlParam;
    $[22] = debouncedUpdateUrlParam;
    $[23] = pagesUrlParam;
    $[24] = pathname;
    $[25] = queryUrlParam;
    $[26] = sortByUrlParam;
    $[27] = updateUrlParamImmediate;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};
export default useAdvancedSearchNextURL;